import { Component, OnInit, HostListener, AfterViewInit, ViewChild, TemplateRef, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

import { MatterSearchComponent } from '../../common/matter-search/matter-search.component';

import { AlertService } from '../../../services/common/alert.service';
import { ToBePaidService } from '../../../services/accounting/to-be-paid.service';
import { VendorService } from '../../../services/accounting/vendor.service';

@Component({
  selector: 'app-to-be-paids',
  templateUrl: './to-be-paids.component.html',
  styleUrls: ['./to-be-paids.component.css'],
})
export class ToBePaidsComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('check_creation_errors_modal', { static: true }) checkCreationErrorsModal: TemplateRef<any>;

  @ViewChild('matterSearch', { static: true }) matterSearchComponent: MatterSearchComponent;

  bankAccounts: Array<any> = [];

  bill_type_names: any = {
    charge: true,
  };

  check_creation_errors: string;

  checkNumbers: Array<any> = [];

  checkNumbersStr: string;

  checkSubmitted: boolean = false;
  checkSubmitting: boolean = false;

  count: number = 0;

  fetchingBankDetails: boolean = false;

  masterPaymentCheckBox: boolean = false;

  openModals: Array<NgbModalRef> = [];

  overdrafted: boolean = false;

  pagination_hidden: boolean = false;

  payment_mode: boolean = false;

  search_options: any = {
    chart_of_accounts: [],
    general_bank_accounts: [],
    per_page: 20,
  };

  selectedPaymentBankAccountId: number | null = null;

  search_params: any = {
    page: 1,
    per_page: 20,
    check_numbers: [],
    contact_ids: [],
    vendor_ids: [],
    statuses: ['O'],
    bill_type_names: ['charge'],
    amount_equality: '=',
    no_pagination: false,
  };

  searching: boolean = false;

  showBankAccounts: boolean = false;

  showToBePaidId: number | null;

  showVendorSidebar: boolean = false;

  statuses: any = {
    O: true,
  };

  to_be_paids: Array<any> = [];

  vendor_autocompletes: Array<any> = [];

  vendors: Array<any> = [];

  vendors_select: Array<any> = [];

  vendorId: number;

  constructor(private alertService: AlertService, private route: ActivatedRoute, private toBePaidService: ToBePaidService, private vendorService: VendorService, private modalService: NgbModal) {
    this.toBePaidService.getSearchOptions().then((response_json) => {
      this.search_options = response_json;
      this.selectDefaultPaymentBankAccount();
      this.vendorService.searchByMatter().then((response_json) => {
        this.vendors_select = response_json;
      });
      this.search();
    });
  }

  // Component lifecycle events
  ngOnInit() {
    let make_payment: boolean = this.route.snapshot.queryParams['make_payment'];
    let vendor_id: number = Number(this.route.snapshot.queryParams['vendor_id']);
    let contact_name: string = this.route.snapshot.queryParams['contact_name'];
    let matter_id: number = Number(this.route.snapshot.queryParams['matter_id']);
    if (make_payment && vendor_id && contact_name) {
      this.vendor_autocompletes.push({
        id: vendor_id,
        label: contact_name,
      });
      this.makePayment();
    } else if (vendor_id && matter_id) {
      this.search_params.matter_id = matter_id;
      this.vendorId = vendor_id;
      setTimeout(() => {
        this.search();
      }, 3000);
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.content_sidebar_scroll();
      this.search_height_maintainer();
    }, 500);
  }

  ngOnDestroy() {
    for (let modal of this.openModals) modal.close();
    this.openModals = [];
  }

  // Component methods
  cancelPayment() {
    this.payment_mode = false;
    this.showBankAccounts = false;
    this.search_params.making_payment = false;
    this.search();
  }

  checkCreationButtonText(): string {
    if (this.checkSubmitting) return 'Creating Check(s)';
    else if (this.fetchingBankDetails) return 'Fetching bank balance';
    else if (!this.selectedPaymentBankAccountId) return 'Select a general bank account';
    else if (this.overdrafted) return 'Total exceeds bank balance';
    let count: number = 0;
    for (let to_be_paid of this.to_be_paids)
      if (to_be_paid.selected_for_payment) {
        count += 1;
        //if(to_be_paid.pay < 0.1)
        //	return 'Amount must be atleast $0.10';
      }
    if (count < 1) return 'Atleast one payment must be selected';
    return 'Create Check(s)';
  }

  checkNumbersCount(): number {
    return this.checkNumbers.length;
  }

  checkNumbersEntered() {
    console.log('changed');
    if (this.checkNumbersStr) {
      let checkNumbers = this.checkNumbersStr.split(',');
      this.checkNumbers = [];
      for (let checkNumber of checkNumbers) {
        checkNumber = checkNumber.trim();
        this.checkNumbers.push(checkNumber);
      }
    }
  }

  clearChecKNumbers() {
    this.checkNumbers = [];
    this.checkNumbersStr = '';
  }

  clearSearch() {
    this.search_params.matter_id = null;
    this.search_params.vendor_ids = [];
    if (this.matterSearchComponent) this.matterSearchComponent.clearSelectedMatter();
    this.clearVendorSelection();
    this.vendor_autocompletes = [];
    this.search_params.account_number = null;
    this.search_params.chart_of_account_id = null;
    this.clearChecKNumbers();
    this.search_params.amount_equality = '=';
    this.search_params.amount = null;
    this.search_params.statuses = ['O'];
    this.search_params.bill_type_names = ['charge'];
    this.search_params.no_pagination = false;
    this.search();
  }

  clearVendorSelection() {
    for (let vendor of this.vendors) vendor.selected = false;
    this.vendors = [];
  }

  createCheck() {
    this.checkSubmitted = true;
    if (this.selectedForPaymentCount() > 0) {
      this.checkSubmitting = true;
      let scope = this;
      let to_be_paids: any = [];
      for (let to_be_paid of this.to_be_paids)
        if (to_be_paid.selected_for_payment) {
          to_be_paids.push({
            id: to_be_paid.id,
            pay: to_be_paid.pay,
          });
        }
      this.toBePaidService
        .createCheck({
          selected_to_be_paids: to_be_paids,
          bank_account_id: this.selectedPaymentBankAccountId,
        })
        .then((response_json) => {
          this.checkSubmitting = false;
          this.check_creation_errors = response_json.html;
          if (response_json.success) {
            this.alertService.alert_status_success(response_json.text);
            this.payment_mode = false;
            this.search_params.making_payment = false;
            this.search();
          } else {
            this.showCheckCreationErrorModal();
          }
        })
        .catch(function () {
          scope.checkSubmitting = false;
          scope.alertService.alert_status_danger('Error creating check(s)');
        });
    } else {
      this.alertService.alert_status_warning('Atleast one charge must be selected for payment');
    }
  }

  disableCheckCreationButton(): boolean {
    if (this.checkSubmitting) return true;
    else if (!this.selectedPaymentBankAccountId) return true;
    else if (this.overdrafted) return true;
    else if (this.fetchingBankDetails) return true;
    let count: number = 0;
    for (let to_be_paid of this.to_be_paids)
      if (to_be_paid.selected_for_payment) {
        count += 1;
        //if(to_be_paid.pay < 0.1)
        //	return true;
      }
    if (count < 1) return true;
    return false;
  }

  loadBankAccountDetails() {
    if (!this.selectedPaymentBankAccountId) {
      this.bankAccounts = [];
      this.overdrafted = false;
      return;
    }
    let chart_of_account_ids: Array<number> = [];
    for (let to_be_paid of this.to_be_paids) if (to_be_paid.selected_for_payment && chart_of_account_ids.indexOf(to_be_paid.chart_of_account_id) < 0) chart_of_account_ids.push(to_be_paid.chart_of_account_id);
    this.fetchingBankDetails = true;
    let scope = this;
    this.toBePaidService
      .getBankAccountDetails(chart_of_account_ids, this.selectedPaymentBankAccountId)
      .then((response_json) => {
        this.fetchingBankDetails = false;
        this.bankAccounts = response_json;
        this.paymentForBankAccounts();
      })
      .catch(function () {
        scope.fetchingBankDetails = false;
      });
  }

  makePayment() {
    this.selectDefaultPaymentBankAccount();
    this.search_params.no_pagination = true;
    this.statuses.O = true;
    this.statuses.P = false;
    this.statuses.C = false;
    this.statuses.V = false;
    this.bill_type_names.payment = false;
    this.search_params.making_payment = true;
    this.masterPaymentCheckBox = true;
    this.search(true);
  }

  onMatterSelect(matter_id: any) {
    this.clearVendorSelection();
    this.search_params.matter_id = matter_id;
    this.vendorService.searchByMatter(matter_id).then((response_json) => {
      this.vendors_select = response_json;
    });
  }

  onVendorSelect(vendorItem: any) {
    for (let vendor of this.vendor_autocompletes) if (vendor.id == vendorItem.id) return;
    this.vendor_autocompletes.push(vendorItem);
  }

  openToBePaid(to_be_paid: any, template: TemplateRef<any>) {
    this.showToBePaidId = to_be_paid.id;
    let toBePaidModal: NgbModalRef = this.modalService.open(template, { size: 'lg' });
    toBePaidModal.result.then(
      (result) => {
        this.showToBePaidId = null;
        this.removeModal(toBePaidModal);
        if (result == 'success') {
        }
      },
      (reason) => {
        this.showToBePaidId = null;
        this.removeModal(toBePaidModal);
        //this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
    this.openModals.push(toBePaidModal);
  }

  pageChanged($event: any) {
    this.search_params.page = $event.page;
    this.search();
  }

  paymentForBankAccounts() {
    this.overdrafted = false;
    for (let bankAccount of this.bankAccounts) {
      let payment: number = 0;
      let chart_of_account_ids = bankAccount.chart_of_account_ids;
      for (let to_be_paid of this.to_be_paids) if (to_be_paid.selected_for_payment && chart_of_account_ids.indexOf(to_be_paid.chart_of_account_id) > -1) payment += Number(to_be_paid.pay);
      bankAccount.payment = payment;
      bankAccount.final_balance = bankAccount.balance - payment;
      if (bankAccount.final_balance < 0) {
        bankAccount.overdraft = true;
        this.overdrafted = true;
      } else bankAccount.overdraft = false;
    }
  }

  paymentBankAccountChanged() {
    this.loadBankAccountDetails();
  }

  selectDefaultPaymentBankAccount() {
    const accounts = this.search_options.general_bank_accounts || [];
    if (accounts.length === 0) {
      this.selectedPaymentBankAccountId = null;
      return;
    }
    if (accounts.some((account: any) => Number(account.id) === Number(this.selectedPaymentBankAccountId))) return;

    const defaultAccount = accounts.find((account: any) => account.is_default) || accounts[0];
    this.selectedPaymentBankAccountId = Number(defaultAccount.id);
    if (this.payment_mode) this.loadBankAccountDetails();
  }

  removeCheckNumber(index: number) {
    this.checkNumbers.splice(index, 1);
    this.checkNumbersStr = this.checkNumbers.join(', ');
  }

  removeModal(modal: NgbModalRef) {
    let index: number = this.openModals.indexOf(modal);
    this.openModals.splice(index, 1);
  }

  removeVendor(index: number) {
    this.vendor_autocompletes.splice(index, 1);
  }

  search(load_payment_mode: boolean = false) {
    this.search_params.vendor_ids = [];
    for (let vendor of this.vendors) this.search_params.vendor_ids.push(vendor.id);

    this.search_params.contact_ids = [];
    for (let vendor of this.vendor_autocompletes) this.search_params.vendor_ids.push(vendor.id);

    this.search_params.statuses = [];
    for (var k in this.statuses) if (this.statuses.hasOwnProperty(k) && this.statuses[k]) this.search_params.statuses.push(k);

    this.search_params.bill_type_names = [];
    for (var k in this.bill_type_names) if (this.bill_type_names.hasOwnProperty(k) && this.bill_type_names[k]) this.search_params.bill_type_names.push(k);

    this.searching = true;

    let scope = this;
    this.toBePaidService
      .getToBePaids(this.search_params)
      .then((response_json) => {
        this.searching = false;
        this.count = response_json.count;
        this.to_be_paids = response_json.result;
        if (this.search_params.no_pagination) this.pagination_hidden = true;
        else this.pagination_hidden = false;
        if (load_payment_mode) this.payment_mode = true;
        if (load_payment_mode || this.payment_mode) {
          this.loadBankAccountDetails();
          this.showBankAccounts = true;
        }
        this.paymentForBankAccounts();
      })
      .catch(function () {
        scope.searching = false;
      });
  }

  selectedForPaymentCount(): number {
    let count: number = 0;
    for (let to_be_paid of this.to_be_paids) if (to_be_paid.selected_for_payment) count += 1;
    return count;
  }

  showCheckCreationErrorModal() {
    this.modalService.open(this.checkCreationErrorsModal).result.then(
      (result) => {},
      (reason) => {}
    );
  }

  statusName(status: string): string {
    switch (status) {
      case 'outstanding':
        return 'warning';
      case 'void':
        return 'dark';
      case 'paid':
        return 'success';
      case 'contested':
        return 'danger';
      default:
        return 'light';
    }
  }

  toggleToBePaidsSelection() {
    if (this.masterPaymentCheckBox) for (let to_be_paid of this.to_be_paids) to_be_paid.selected_for_payment = true;
    else for (let to_be_paid of this.to_be_paids) to_be_paid.selected_for_payment = false;
    this.paymentForBankAccounts();
  }

  toggleVendor(selectedVendor: any) {
    if (selectedVendor.selected) {
      if (this.vendors.indexOf(selectedVendor) > -1) return;
      this.vendors.push(selectedVendor);
    } else {
      let idx = this.vendors.indexOf(selectedVendor);
      if (idx > -1) this.vendors.splice(idx, 1);
    }
  }

  toggleVendorSidebar() {
    this.showVendorSidebar = !this.showVendorSidebar;
    if (this.showVendorSidebar) {
      let scope = this;
      window.setTimeout(function () {
        scope.content_sidebar_scroll();
        scope.search_height_maintainer();
      }, 10);
    }
  }

  totalCheckPaymentAmount(): number {
    let total: number = 0;
    for (let to_be_paid of this.to_be_paids) if (to_be_paid.selected_for_payment) total += Number(to_be_paid.pay);
    return total;
  }

  // Positioning events and methods
  @HostListener('window:scroll', ['$event'])
  window_scroll(event: Event) {
    this.content_sidebar_scroll();
    this.search_height_maintainer();
  }

  @HostListener('window:resize', ['$event'])
  window_resize(event: Event) {
    this.content_sidebar_scroll();
    this.search_height_maintainer();
  }

  content_sidebar_scroll() {
    var content_main = document.getElementById('content-main');
    var content_sidebar = document.getElementById('content-sidebar');
    var vendor_sidebar = document.getElementById('vendor-sidebar');
    var sidebar_height = window.innerHeight;
    if (content_sidebar && content_main) {
      if (content_main.getBoundingClientRect().top > 19) {
        content_sidebar.style.position = 'absolute';
        content_sidebar.style.top = content_main.offsetTop + 'px';
        if (vendor_sidebar) {
          vendor_sidebar.style.position = 'absolute';
          vendor_sidebar.style.top = content_main.offsetTop + 'px';
        }
        sidebar_height -= content_main.getBoundingClientRect().top + 20;
        //console.log('greater ' + matter_sidebar.style.top);
      } else {
        content_sidebar.style.position = 'fixed';
        content_sidebar.style.top = '20px';
        if (vendor_sidebar) {
          vendor_sidebar.style.position = 'fixed';
          vendor_sidebar.style.top = '20px';
        }
        sidebar_height -= content_sidebar.getBoundingClientRect().top + 20;
        //console.log('lesser ' + matter_sidebar.style.top);
      }

      if (content_sidebar.clientHeight != sidebar_height) content_sidebar.style.height = sidebar_height + 'px';
      if (vendor_sidebar && vendor_sidebar.clientHeight != sidebar_height) vendor_sidebar.style.height = sidebar_height + 'px';
    }
  }

  search_height_maintainer() {
    var content_sidebar = document.getElementById('content-sidebar');
    var content_search = document.getElementById('search-form');
    var vendor_select = document.getElementById('vendor-select');
    if (content_sidebar && content_search) {
      var search_height = content_sidebar.clientHeight - 95;
      if (search_height > 0) {
        content_search.style.height = search_height + 'px';
        if (vendor_select) vendor_select.style.height = search_height + 'px';
      } else {
        content_search.style.height = '0px';
        if (vendor_select) vendor_select.style.height = '0px';
      }
    }
  }
}
